module.exports = __webpack_public_path__ + "static/media/carrot-cake.ee8ac7e1.png";